const getStopsDirections = (stops) => {
  if (!stops.length) {
    return null;
  }

  const firstStop = stops[0];
  const lastStop = stops[stops.length - 1];

  const origin = new window.google.maps.LatLng(firstStop.latitude, firstStop.longitude);
  const destination = new window.google.maps.LatLng(lastStop.latitude, lastStop.longitude);
  const waypoints = stops
    .filter((_, key) => key !== 0 && key !== stops.length - 1)
    .map((stop, key) => {
      return {
        location: new window.google.maps.LatLng(stop.latitude, stop.longitude),
        stopover: true,
      };
    });

  return {
    avoidFerries: true,
    origin,
    destination,
    waypoints,
    optimizeWaypoints: false,
    travelMode: window.google.maps.TravelMode.DRIVING,
  };
};

const getBoundsWithStops = (stops) => {
  const googleBounds = new window.google.maps.LatLngBounds();
  stops.reduce((_, stop) => {
    const p = new window.google.maps.LatLng(stop?.latitude, stop?.longitude);
    googleBounds.extend(p);
    return googleBounds;
  }, googleBounds);

  return googleBounds;
};

const getCenterAndNorthEast = (bounds) => {
  const center = bounds.getCenter();
  const centerLatitude = center.lat();
  const centerLongitude = center.lng();

  const northEast = bounds.getNorthEast();
  const northEastLatitude = northEast.lat();
  const northEastLongitude = northEast.lng();

  return {
    center: {
      latitude: centerLatitude,
      longitude: centerLongitude,
    },
    northEast: {
      latitude: northEastLatitude,
      longitude: northEastLongitude,
    },
  };
};

const getDirectionsOptions = ({ strokeColor = 'red' }) => ({
  suppressInfoWindows: true,
  suppressMarkers: true,
  preserveViewport: true,
  suppressPolylines: false,
  polylineOptions: {
    clickable: false,
    zIndex: 4,
    strokeOpacity: 0,
    icons: [
      {
        icon: {
          path: 'M 0,-1 0,1',
          strokeColor: strokeColor,
          strokeOpacity: 1,
          scale: 3,
        },
        offset: '0',
        repeat: '15px',
      },
    ],
  },
});

export { getBoundsWithStops, getDirectionsOptions, getStopsDirections, getCenterAndNorthEast };
